'use client';

import { cx } from '../utils/cx';

export interface LoadingProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function Spinner({ className }: { className?: string }) {
  return (
    <svg className={cx('animate-spin', className)} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      <path
        className="opacity-75"
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Loading({ text = 'Loading...', size = 'md', className }: LoadingProps) {
  const sizeClasses: Record<NonNullable<LoadingProps['size']>, string> = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const textSizeClasses: Record<NonNullable<LoadingProps['size']>, string> = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <div
      className={cx('flex flex-col items-center justify-center gap-3 py-8', className)}
      role="status"
      aria-label="Loading content"
    >
      <Spinner className={cx('text-progress', sizeClasses[size])} />
      {text ? <p className={cx('animate-pulse text-tertiary', textSizeClasses[size])}>{text}</p> : null}
    </div>
  );
}

Loading.displayName = 'Loading';
